import {
  GET_SMS_CAMPAIGNS_REQUEST,
  GET_SMS_CAMPAIGNS_SUCCESS,
  GET_SMS_CAMPAIGNS_FAILURE,
  DELETE_SMS_CAMPAIGN_SUCCESS,
  POST_SMS_CAMPAIGN_SUCCESS,
  PUT_SMS_CAMPAIGN_SUCCESS,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
  from: 1,
  to: 1,
  total: 1,
  refetchSmsCampaigns: false,
};

const smsCampaignsReducer = (state = initialState, {
  type, error, data, meta,
}) => {
  switch (type) {
    case GET_SMS_CAMPAIGNS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_SMS_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        from: meta.from,
        to: meta.to,
        total: meta.total,
        loading: false,
      };
    case GET_SMS_CAMPAIGNS_FAILURE:
      return { ...state, loading: false, error };
    case DELETE_SMS_CAMPAIGN_SUCCESS:
    case PUT_SMS_CAMPAIGN_SUCCESS:
    case POST_SMS_CAMPAIGN_SUCCESS:
      return {
        ...state,
        refetchSmsCampaigns: !state.refetchSmsCampaigns,
      };
    default:
      return state;
  }
};

export default smsCampaignsReducer;
